import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import OrderDetails from '../components/OrderDetails';
import { SocketRPC, socketEmit } from '../lib/socket';
import useChatrooms from '../store/chatrooms';
import { useOrders } from '../store/orders';
import useUser from '../store/user';

export default function HistoricalOrderDetailPage() {
	const routerParams = useParams();
	const { orders, setOrders } = useOrders();
	const { user } = useUser();
    const { producerKey, orderSourceKey, partnerKey } = user || {};
	const chatroom = useChatrooms(
		(state) => state.chatrooms[routerParams.orderKey!]
	);
	const hasNewMessage = chatroom ? !chatroom.hasBeenReadByParticipant : false;

	useEffect(() => {

		if (orders[routerParams.orderKey!]) {
			return;
		}

		Promise.resolve().then(() => {
			return socketEmit(SocketRPC.GetHistoricalOrder, {
				user,
                partnerKey,
                orderSourceKey,
                producerKey,
				orderKey: routerParams.orderKey,
			});
		})
        .then((res) => {
            if (!res.success) {
                throw new Error(res.error)
            }

			const fetchedOrder = res.order;

            setOrders({
				...orders,
				[fetchedOrder.orderKey]: fetchedOrder,
			});
        })
        .catch((err) =>
				{
					toast.error(
						`Error searching archived orders. Please try again`
					);
					console.log(`Could not get order`, err);
				}
        );
	}, [routerParams.orderKey]);

	return OrderDetails({
		order: routerParams ? orders[routerParams.orderKey!] : null,
		mode: 'historical-order',
		hasNewMessage,
	});
}
